module.exports = __webpack_public_path__ + "img/grand-room-2.30e7ac25.jpg";